<template>
  <div>
    <div class="modal-dim on">
      <!--'on 추가'-->
      <div class="modal-wrap">
        <div class="modal-inner whole">
          <div class="modal">
            <header class="header">
              <div class="inner">
                <div class="left">
                  <button class="h-btn back" @click="$emit('close')"></button>
                </div>
                <h2 class="text">이용약관</h2>
              </div>
            </header>
            <div class="modal-con">
              <div class="modal-txt">
                <div class="txt-con">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, bibendum quis purus
                    eu, ullamcorper malesuada quam. Nam vitae tellus lectus. Sed porttitor nec massa eu faucibus.
                    Maecenas at justo nisi. Fusce eget turpis lorem. Lorem ipsum dolor sit amet, consectetur adipiscing
                    elit. Pellentesque erat arcu, bibendum quis purus eu, ullamcorper malesuada quam. Nam vitae tellus
                    lectus. Sed porttitor nec massa eu faucibus. Maecenas at justo nisi. Fusce eget turpis lorem. Lorem
                    ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, bibendum quis purus eu,
                    ullamcorper malesuada quam. Nam vitae tellus lectus. Sed porttitor nec massa eu faucibus. Maecenas
                    at justo nisi. Fusce eget turpis lorem. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Pellentesque erat arcu, bibendum quis purus eu, ullamcorper malesuada quam. Nam vitae tellus lectus.
                    Sed porttitor nec massa eu faucibus. Maecenas at justo nisi. Fusce eget turpis lorem. Lorem ipsum
                    dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, bibendum quis purus eu,
                    ullamcorper malesuada quam. Nam vitae tellus lectus. Sed porttitor nec massa eu faucibus. Maecenas
                    at justo nisi. Fusce eget turpis lorem. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Pellentesque erat arcu, bibendum quis purus eu, ullamcorper malesuada quam. Nam vitae tellus lectus.
                    Sed porttitor nec massa eu faucibus. Maecenas at justo nisi. Fusce eget turpis lorem. Lorem ipsum
                    dolor sit amet, consectetur adipiscing elit. Pellentesque erat arcu, bibendum quis purus eu,
                    ullamcorper malesuada quam. Nam vitae tellus lectus. Sed porttitor nec massa eu faucibus. Maecenas
                    at justo nisi. Fusce eget turpis lorem.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TERMS'
};
</script>
<script setup>
import { defineEmits } from 'vue';
const emit = defineEmits(['close']);
</script>
